import { render, staticRenderFns } from "./RegularizationAddForm.vue?vue&type=template&id=5acddec8&scoped=true&"
import script from "./RegularizationAddForm.vue?vue&type=script&lang=js&"
export * from "./RegularizationAddForm.vue?vue&type=script&lang=js&"
import style0 from "./RegularizationAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegularizationAddForm.vue?vue&type=style&index=1&id=5acddec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acddec8",
  null
  
)

export default component.exports